import React, { FC, memo, useMemo } from 'react';
import { TextProps } from '@types';
import { TextStyled } from './Text.styled';

// eslint-disable-next-line react/display-name
const Text: FC<TextProps> = memo(
    // eslint-disable-next-line react/prop-types
    ({ as, textVariant, textWeight, children, ...restProps }) => {
        const componentType = useMemo(() => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let type: keyof JSX.IntrinsicElements | React.ComponentType<any> = (textVariant as keyof JSX.IntrinsicElements) || 'span';

            if (
                !textVariant ||
                textVariant == 'button1' ||
                textVariant == 'text1' ||
                textVariant == 'welcometext' ||
                textVariant == 'text2' ||
                textVariant == 'text3'
            ) {
                type = textWeight === 'Strong' || textWeight === 'ExtraStrong' ? 'strong' : 'span';
            }

            return type;
        }, [textWeight, textVariant]);
        return (
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            <TextStyled {...{ textVariant, textWeight, ...restProps }} as={as || componentType}>
                {children}
            </TextStyled>
        );
    }
);

Text.defaultProps = {
    lineThrough: false,
    uppercase: false,
    fullWidth: false,
    decoration: 'inherit',
    textColor: 'inherit'
};

export default Text;
